import { useEffect, useState } from "react";

export const useScreenDetector = () => {
    if (typeof window === 'undefined') return { isMobile: false, isDesktop: true };
    
    const [width, setWidth] = useState<number>(window?.innerWidth || 0);

    const handleWindowSizeChange = () => {
        setWidth(window?.innerWidth || 0);
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;

        window?.addEventListener("resize", handleWindowSizeChange);

        return () => {
            if (typeof window === 'undefined') return;
            window?.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    // todo временно убираем пока адаптируем планшет как мобильную версию
    // const isMobile = width <= 768;
    // const isTablet = width <= 1024;

    const isMobile = width <= 1024;
    const isDesktop = width > 1024;
    return { isMobile, isDesktop };
};